import { Tooltip } from 'antd';
import styled, { css } from 'styled-components';

import theme from '../../assets/theme';
import { typeToActivityMap } from '../../utils/creator';
import { zIndexes } from '../../utils/zIndexes';
import { IconWrapper } from '../_atoms/IconWrapper';
import { Slide } from './slide.types';
import { slideTypeToIcon } from './slideUtil';

const ActivityIndicator = ({
  slide,
  onClick,
  isSlideList = false,
}: {
  slide: Slide;
  onClick?: () => void;
  isSlideList?: boolean;
}) => {
  return (
    <>
      {slideTypeToIcon(slide.type) !== null && (
        <Tooltip
          mouseEnterDelay={0.5}
          visible={isSlideList === true ? false : undefined}
          title={`${typeToActivityMap(slide.type)?.title} activity, click here to change`}
        >
          <HoverableActivityOverlayItem
            $isSlideList={isSlideList}
            onClick={() => onClick && onClick()}
          >
            <IconWrapper
              color="white"
              height={isSlideList ? '160px' : '40px'}
              width={isSlideList ? '160px' : '40px'}
            >
              {slideTypeToIcon(slide.type)}
            </IconWrapper>
          </HoverableActivityOverlayItem>
        </Tooltip>
      )}
    </>
  );
};

export default ActivityIndicator;

const HoverableActivityOverlayItem = styled.div<{ $isSlideList: boolean }>`
  background-color: rgba(122, 122, 122, 0.76);
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${zIndexes('ACTIVITY_OVERLAY_ITEM')};
  border-radius: 20px 0px 20px 0px;
  height: 80px;
  width: 80px;
  display: flex;
  justify-content: center;
  padding: 25px;
  transition: all 0.2s ease-in-out;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
  cursor: pointer;

  ${({ $isSlideList }) =>
    $isSlideList &&
    css`
      border-radius: 0px 0px 80px 0px;
      height: 320px;
      width: 320px;
      padding: 100px;
    `}

  &:hover {
    box-shadow: none;
    background-color: ${theme.colors.blue};
  }
`;
